import { Component, ChangeDetectionStrategy, ViewChild, Inject, Optional } from "@angular/core";
import { FormFieldGroupComponent } from "./form-field-group-component";
import { FormRootDirective } from "../../form/form-root.directive";
import { FIELD_NAME } from "../form-field-injector";

@Component({
  selector: "dynamic-form-group-default",
  template: `
    <div class="group-default">
      <label>
        <h3>{{ name }}</h3>
      </label>
      <form-root></form-root>
    </div>
  `,
  styles: [
    `
      .group-default {
        border: 1px solid grey;
        padding: 5px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupComponent implements FormFieldGroupComponent {
  @ViewChild(FormRootDirective, { static: true })
  formRoot: FormRootDirective;

  constructor(@Optional() @Inject(FIELD_NAME) public name: string) {}
}
